/**
 * Portal Manta · MainNavSidebar
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { MAIN_TABS } from '../../globals.js';
import { M } from '../../tokens/colors.js';

function MainNavSidebar({mainTab,setMainTab}){
  return(<div style={{
    width:62,
    background:'linear-gradient(180deg,#0D1526 0%,#1E2A4A 100%)',
    display:'flex',flexDirection:'column',alignItems:'center',
    padding:'10px 0',flexShrink:0,
    boxShadow:'2px 0 12px rgba(0,0,0,.25)',
    borderRight:'1px solid rgba(255,255,255,.06)'
  }}>
    {/* Logo M */}
    <div style={{
      width:36,height:36,borderRadius:9,
      background:'linear-gradient(135deg,#D4682A,#E8834A)',
      display:'flex',alignItems:'center',justifyContent:'center',
      marginBottom:16,boxShadow:'0 3px 10px rgba(212,104,42,.4)',
      flexShrink:0
    }}>
      <span style={{color:'#fff',fontSize:14,fontWeight:800,letterSpacing:'-1px',fontFamily:'system-ui'}}>M</span>
    </div>
    {MAIN_TABS.map(t=>{
      const active=mainTab===t.k;
      return(<div
        key={t.k}
        onClick={()=>setMainTab(t.k)}
        title={`${t.n}. ${t.l}`}
        style={{
          width:50,
          margin:'3px 0',
          padding:'10px 4px',
          borderRadius:8,
          cursor:'pointer',
          background:active?'rgba(212,104,42,.25)':'transparent',
          color:active?'#F4A76A':'rgba(255,255,255,0.5)',
          display:'flex',
          flexDirection:'column',
          alignItems:'center',
          gap:4,
          transition:'all .14s',
          borderLeft:active?'2px solid #D4682A':'2px solid transparent',
        }}
        onMouseEnter={e=>{if(!active){e.currentTarget.style.background='rgba(255,255,255,.07)';e.currentTarget.style.color='rgba(255,255,255,.85)';}}}
        onMouseLeave={e=>{if(!active){e.currentTarget.style.background='transparent';e.currentTarget.style.color='rgba(255,255,255,0.5)';}}}
      >
        <span style={{fontSize:17,lineHeight:1}}>{t.icon}</span>
        <span style={{fontSize:8,fontWeight:700,letterSpacing:'.04em',textTransform:'uppercase'}}>{t.n}</span>
      </div>);
    })}
    <div style={{marginTop:'auto',padding:'8px 0',fontSize:7.5,color:'rgba(255,255,255,0.2)',writingMode:'vertical-rl',letterSpacing:'.18em',fontWeight:700,textTransform:'uppercase'}}>MANTA</div>
  </div>);
}

export { MainNavSidebar };
export default MainNavSidebar;
